import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import ReactGA from 'react-ga';
import App from './App';
import './intl';

const isProduction = process.env.REACT_APP_HOST_ENV === 'production';
const isDemo = process.env.REACT_APP_HOST_ENV === 'demo';
const SENTRY_DSN = isProduction
    ? 'https://02acd54aca004c2eb905fc7ccd883c63@o431833.ingest.sentry.io/5450327'
    : undefined;

let GA_ID = '';

if (isProduction) {
    GA_ID = 'UA-218796668-1';
}

if (isDemo) {
    GA_ID = 'UA-218796668-2';
}


ReactGA.initialize(GA_ID);

Sentry.init({ dsn: SENTRY_DSN });

ReactDOM.render(<App />, document.getElementById('root'));
